__turbopack_context__.v({
  "active": "Rijt2a_active",
  "bottomCenter": "Rijt2a_bottomCenter",
  "bottomLeft": "Rijt2a_bottomLeft",
  "bottomRight": "Rijt2a_bottomRight",
  "ctaNavWrapper": "Rijt2a_ctaNavWrapper",
  "cursorTracked": "Rijt2a_cursorTracked",
  "cursorTracker": "Rijt2a_cursorTracker",
  "description": "Rijt2a_description",
  "dot": "Rijt2a_dot",
  "embla": "Rijt2a_embla",
  "emblaContainer": "Rijt2a_emblaContainer",
  "emblaSlide": "Rijt2a_emblaSlide",
  "hidden": "Rijt2a_hidden",
  "imageContainer": "Rijt2a_imageContainer",
  "indicatorWrapper": "Rijt2a_indicatorWrapper",
  "isActive": "Rijt2a_isActive",
  "mainImage": "Rijt2a_mainImage",
  "mainVideo": "Rijt2a_mainVideo",
  "middleCenter": "Rijt2a_middleCenter",
  "middleLeft": "Rijt2a_middleLeft",
  "middleRight": "Rijt2a_middleRight",
  "navigation": "Rijt2a_navigation",
  "nearIndicator": "Rijt2a_nearIndicator",
  "objectBottom": "Rijt2a_objectBottom",
  "objectFitContain": "Rijt2a_objectFitContain",
  "objectFitCover": "Rijt2a_objectFitCover",
  "progress": "Rijt2a_progress",
  "root": "Rijt2a_root",
  "slideTextWrapper": "Rijt2a_slideTextWrapper",
  "stickyWrapper": "Rijt2a_stickyWrapper",
  "title": "Rijt2a_title",
  "topCenter": "Rijt2a_topCenter",
  "topLeft": "Rijt2a_topLeft",
  "topRight": "Rijt2a_topRight",
});
